import { Star } from 'lucide-react'

export default function StarRatingDisplay({
  rating,
  size = 16,
}: {
  rating: number
  size?: number
}) {
  return (
    <div className="inline-flex items-center gap-1">
      {Array.from({ length: 5 }, (_, index) => {
        const active = index < Math.round(rating)
        return (
          <Star
            key={index}
            size={size}
            className={active ? 'fill-amber-400 text-amber-400' : 'text-slate-300'}
          />
        )
      })}
    </div>
  )
}
